import { GetCookie } from "api/jwt";
import { CreatePromoCode } from "api/secureApi.ts";
import { useState } from "react";

const usePromoCode = () => {
  const [isLoading, setIsLoading] = useState();
  const [promoCode, setPromoCode] = useState();

  const generatePromoCode = async () => {
    setIsLoading(true);
    const token = GetCookie("idToken");
    const promoCode = await CreatePromoCode(token);
    setPromoCode(promoCode.promoCode);
    setIsLoading(false);
  };

  return { isLoading, promoCode, generatePromoCode };
};

export default usePromoCode;
